import React,{useState} from "react";
import './App.css';
import {Board} from "./components/Board"
import { ScoreBoard } from "./components/ScoreBoard";
import {ResetButton} from "./components/ResetButton";
import {Title} from "./components/Title";
import reset from "./audio/board-start.mp3";
import over from "./audio/game-over.mp3";
import pencil from "./audio/pencil.mp3";
import {Howl, Howler} from "howler";


function App() {
  const audioClips = [
    {sound: reset},
    {sound: over},
    {sound: pencil},
  ]
  const WIN_CONDITIONS = [
    [0,1,2],
    [3,4,5],
    [6,7,8],
    [0,3,6],
    [1,4,7],
    [2,5,8],
    [0,4,8],
    [2,4,6]
  ]
  const [board, setBoard] = useState(Array(9).fill(null));
  const [xPlaying, setXPlaying] = useState(true);
  const [scores, setScores] = useState({xScore:0, oScore:0});
  const [gameOver, setGameOver] = useState(false);
  const [x, setX] = useState(-1);
  const [y, setY] = useState(-1);
  const [z, setZ] = useState(-1);
  const handleBoxClick = (boxIdx) => {
    const updatedBoard = board.map((value, idx) => {
      if(idx === boxIdx) {
        return xPlaying === true?"X":"O";
      }else {
        return value;
      }
    })
    const winner = checkWinner(updatedBoard);
    if(winner) {
      SoundPlay(audioClips[1].sound);
      if(winner === "O") {
        let {oScore} = scores;
        oScore += 1;
        setScores({...scores,oScore});
      }else {
        let {xScore} = scores;
        xScore += 1;
        setScores({...scores,xScore});
      }
    }else {
      SoundPlay(audioClips[2].sound);
    }
    setBoard(updatedBoard);
    setXPlaying(!xPlaying);
  }
  const checkWinner = (board) => {
    for(let i=0;i<WIN_CONDITIONS.length;i++) {
      const [x1,y1,z1] = WIN_CONDITIONS[i];
      if(board[x1] && board[x1] === board[y1] && board[x1] === board[z1]) {
        setX(x1);
        setY(y1);
        setZ(z1);
        setGameOver(true);
        return board[x1];
      }
    }
  }
  const resetBoard = () => {
    SoundPlay(audioClips[0].sound);
    setGameOver(false);
    setX(-1);
    setY(-1);
    setZ(-1);
    setBoard(Array(9).fill(null));
    setXPlaying(true);
  }
  const SoundPlay = (src) => {
    Howler.volume(0.8);
    const sound = new Howl({
        src
    })
    sound.play();
  }
  return (
    <div className="App">
      <Title />
      <ScoreBoard scores={scores} xPlaying={xPlaying} />
      <Board board={board} onClick={gameOver? resetBoard:handleBoxClick} x={x} y={y} z={z} />
      <ResetButton resetBoard={resetBoard}/>
    </div>
  );
}

export default App;
